import React, { Component } from "react";
import * as PropTypes from "prop-types";
import { Col, Form, Input, message, Modal, Row, Select, Spin, Switch } from "antd";

import { roleAndPermissionService, teamsService, userService } from "./../../redux/services";

import { UIDrawerForm, UIFormSection, UISwitchField, UIUpload } from "./../../components";

const formId = `form-drawer-${Math.floor(Math.random() * 10001)}`;

class Create extends Component {
	static propTypes = {
		visible   : PropTypes.bool.isRequired,
		onComplete: PropTypes.func.isRequired,
		onClose   : PropTypes.func.isRequired,
	};

	constructor(props) {
		super(props);

		this.state = {
			isLoading        : true,
			isSending        : false,
			canSelectAllTeams: false,
			roles            : [],
			rolesSelected    : [],
			teams            : [],
			teamsIsLoadind   : false,
			teamsPage        : 1,
			teamsSearch      : '',
			teamsHasMore     : false,
			passwordRandom   : true,
		};
	}

	onOpen = () => {
		this.setState({
			isLoading: true,
		});

		roleAndPermissionService.getAutocomplete({
			orderBy: "is_system:desc|name:asc",
		})
		.then((response) => {
			this.setState({
				isLoading: false,
				roles    : response.data.data,
			});
		})
		.catch((data) => {
			Modal.error({
				title  : "Ocorreu um erro!",
				content: String(data),
				onOk   : () => {
					// Force close
					return this.onClose();
				}
			});
		});

		this.fetchTeams();
	};

	resetFields = () => {
		this.form.resetFields();
		this.upload && this.upload.reset();

		this.setState({
			roles         : [],
			rolesSelected : [],
			passwordRandom: true,
		});
	};

	onClose = () => {
		// Reset fields
		this.resetFields();

		// Callback
		this.props.onClose();
	};

	onFinish = (values) => {
		const {rolesSelected} = this.state;

		if( !rolesSelected.length )
		{
			Modal.error({
				title  : "Ocorreu um erro!",
				content: "Selecione pelo menos um papél.",
			});

			return false;
		}

		this.setState({
			isSending: true,
		});

		const data = {...values};

		// Roles
		data.roles = rolesSelected;

		const file = this.upload.getFiles();

		data.avatar = file.files.length ? file.files[0] : null;

		userService.create(data)
		.then((response) => {
			this.setState({
				isSending: false,
			});

			// Reset fields
			this.resetFields();

			// Success message
			message.success("Registro cadastrado com sucesso.");

			// Callback
			this.props.onComplete();
		})
		.catch((data) => {
			this.setState({
				isSending: false,
			});

			Modal.error({
				title  : "Ocorreu um erro!",
				content: String(data),
			});
		});
	};

	onChangeRole = (uuid, checked) => {
		const {rolesSelected} = this.state;

		let newRolesSelected = [...rolesSelected];
		const indexSelected  = newRolesSelected.indexOf(uuid);

		if( checked )
		{
			if( indexSelected === -1 )
			{
				newRolesSelected.push(uuid);
			}
		}
		else
		{
			if( indexSelected !== -1 )
			{
				newRolesSelected.splice(indexSelected, 1);
			}
		}

		this.setState({
			rolesSelected: newRolesSelected,
		});
	};

	fetchTeams = (search = '', page = 1) => {
		const limit = 20;

		const data = {
			ativo : 1,
			search: search,
			page  : page,
			limit : limit,
		};

		this.setState({
			teamsIsLoadind: true,
		});

		teamsService.getAll(data)
		.then((response) => {
			this.setState((prevState) => ({
				teams            : page === 1 ? response.data.data : [...prevState.teams, ...response.data.data],
				teamsIsLoadind   : false,
				teamsPage        : page,
				teamsSearch      : search,
				teamsHasMore     : (page * limit) < response.data.meta.total,
				canSelectAllTeams: response.data.pode_selecionar_todos,
			}));
		})
		.catch((data) => {
			this.setState({
				teamsIsLoadind: false,
			});

			Modal.error({
				title  : "Ocorreu um erro!",
				content: String(data),
			});
		});
	};

	onSearchTeams = (search) => {
		this.fetchTeams(search, 1);
	};

	onPopupScrollTeams = (e) => {
		const {teamsIsLoadind, teamsHasMore, teamsPage, teamsSearch} = this.state;

		const target = e.target;

		if( !teamsIsLoadind && teamsHasMore && (target.scrollTop + target.offsetHeight >= target.scrollHeight - 10) )
		{
			this.fetchTeams(teamsSearch, teamsPage + 1);
		}
	};

	renderRoles = () => {
		const {roles, rolesSelected} = this.state;

		if( !roles.length )
		{
			return <p className="byp-role-option-empty">Nenhum papel disponível.</p>
		}

		return roles.map((role, index) => {
			const isSelected = rolesSelected.indexOf(role.uuid) !== -1;

			return (
				<div
					key={index}
					className={`byp-role-option ${isSelected ? "byp-role-option-selected" : ""}`}
					onClick={() => this.onChangeRole(role.uuid, !isSelected)}>
					{/* O clique é da linha inteira; a caixa só mostra o estado */}
					<span className={`byp-role-option-check ${isSelected ? "byp-role-option-check-on" : ""}`}>
						{isSelected && <i className="fas fa-check" />}
					</span>
					<span className="byp-role-option-icon"><i className="fas fa-crown" /></span>
					<span className="byp-role-option-text">
						<span className="byp-role-option-name">{role.name}</span>
						{role.description && <span className="byp-role-option-description">{role.description}</span>}
					</span>
				</div>
			)
		});
	};

	render() {
		const {visible} = this.props;

		const {isLoading, isSending, roles, rolesSelected, passwordRandom, teams, teamsIsLoadind, canSelectAllTeams} = this.state;

		const isGestor = roles.some(role => rolesSelected.includes(role.uuid) && role.is_gestor);

		return (
			<UIDrawerForm
				visible={visible}
				width={700}
				onClose={this.onClose}
				isLoading={isLoading}
				isSending={isSending}
				formId={formId}
				icon={<i className="fal fa-users" />}
				title="Incluir novo usuário"
				subtitle="Preencha os dados abaixo para criar um novo usuário no sistema.">
				<Form
					ref={el => this.form = el}
					id={formId}
					layout="vertical"
					scrollToFirstError
					onFinish={this.onFinish}
					initialValues={{
						password_random: true,
						is_active      : true,
					}}>
					<UIFormSection
						icon={<i className="fal fa-user" />}
						title="Dados do usuário">
						<Row gutter={16}>
							<Col xs={24} md={6}>
								<UIUpload
									name="avatar"
									ref={el => this.upload = el}
									label="Avatar"
									labelError="Avatar"
									acceptedFiles={['jpg', 'jpeg', 'png']}
								/>
							</Col>
							<Col xs={24} md={18}>
								<Form.Item name="name" label="Nome" hasFeedback rules={[{required: true, message: "Campo obrigatório."}]}>
									<Input placeholder="Digite o nome completo do usuário" />
								</Form.Item>
								<Form.Item name="email" label="E-mail" hasFeedback rules={[
									{required: true, message: "Campo obrigatório."},
									{type: "email", message: "Informe um e-mail válido."},
								]}>
									<Input placeholder="Digite o e-mail do usuário" />
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={16}>
							<Col xs={24} md={12}>
								<UISwitchField
									stacked
									title="Gerar senha aleatória"
									description="Uma senha será gerada e enviada para o e-mail do usuário.">
									<Form.Item name="password_random" valuePropName="checked" noStyle>
										<Switch onChange={(checked) => this.setState({passwordRandom: checked})} />
									</Form.Item>
								</UISwitchField>
							</Col>
							<Col xs={24} md={12}>
								<UISwitchField
									stacked
									title="Ativo"
									description="Usuário ativo no sistema.">
									<Form.Item name="is_active" valuePropName="checked" noStyle>
										<Switch />
									</Form.Item>
								</UISwitchField>
							</Col>
						</Row>
						{!passwordRandom && (
							<Row gutter={16}>
								<Col xs={24} md={12}>
									<Form.Item name="password" label="Senha" hasFeedback rules={[
										{required: true, message: "Campo obrigatório."},
										{min: 6, message: "Deve conter no mínimo 6 caracteres."},
									]}>
										<Input type="password" />
									</Form.Item>
								</Col>
								<Col xs={24} md={12}>
									<Form.Item
										name="password_confirmation"
										label="Confirmar senha"
										hasFeedback
										dependencies={['password']}
										rules={[
											{required: true, message: "Campo obrigatório."},
											({getFieldValue}) => ({
												validator(rule, value) {
													if( !value || getFieldValue('password') === value )
													{
														return Promise.resolve();
													}

													return Promise.reject("Deve conter o mesmo valor de Nova senha.");
												},
											}),
										]}>
										<Input type="password" />
									</Form.Item>
								</Col>
							</Row>
						)}
						{isGestor && (
							<Row gutter={16}>
								<Col xs={24}>
									<Form.Item name="teams" label="Fluxos de Aprovação" hasFeedback rules={[{required: true, message: "Campo obrigatório."}]}>
										<Select
											mode="multiple"
											optionFilterProp="children"
											filterOption={(input, option) =>
												(typeof option.children === "string"
													? option.children
													: option.children.props.children
												)
												.toLowerCase()
												.indexOf(input.toLowerCase()) >= 0
											}
											allowClear
											placeholder="Selecione o(s) fluxos de aprovação(s)"
											notFoundContent={teamsIsLoadind ? <Spin indicator={<i className="fad fa-spinner-third fa-spin" />} /> : null}
											onSearch={this.onSearchTeams}
											onPopupScroll={this.onPopupScrollTeams}
											showSearch>
											{canSelectAllTeams && <Select.Option value="todos">Todos</Select.Option>}
											{teams.map((item, index) => (
												<Select.Option key={index} value={item.uuid}>{item.nome}</Select.Option>
											))}
										</Select>
									</Form.Item>
								</Col>
							</Row>
						)}
					</UIFormSection>
					<UIFormSection
						icon={<i className="fal fa-crown" />}
						title="Papéis e Permissões"
						description="Defina o papel do usuário no sistema.">
						<div className="byp-role-options">
							{this.renderRoles()}
						</div>
					</UIFormSection>
				</Form>
			</UIDrawerForm>
		)
	}
}

export default Create;
